<script lang="ts">
  import { SETTING_USER_PHONE, setSetting } from '$lib/db/settings';
  import { t } from '$lib/i18n/index.svelte';
  import { isValidNumber, normalizeNumber } from '$lib/protocol/registration';

  import Banner from '../parts/Banner.svelte';

  // First launch: the ONE thing the app needs to know about its user — the
  // number companies will text verification codes to. Asked once, changeable in
  // Settings, and from here on adding a company is back to a single field.
  let { ondone }: { ondone: (phone: string) => void } = $props();

  let value = $state('');
  let invalid = $state(false);

  async function save(): Promise<void> {
    const normalized = normalizeNumber(value);
    if (!isValidNumber(normalized)) {
      invalid = true;
      return;
    }
    await setSetting(SETTING_USER_PHONE, normalized);
    ondone(normalized);
  }
</script>

<div class="onboarding">
  <div class="logo" aria-hidden="true">D</div>
  <h1>{t('onboarding.title')}</h1>
  <p>{t('onboarding.body')}</p>
  <label for="onboarding-number" class="visually-hidden">{t('onboarding.title')}</label>
  <input
    id="onboarding-number"
    type="tel"
    inputmode="tel"
    autocomplete="tel"
    placeholder="+48 600 100 200"
    bind:value
    oninput={() => (invalid = false)}
    onkeydown={(event) => {
      if (event.key === 'Enter') void save();
    }}
  />
  {#if invalid}
    <Banner kind="warn" text={t('add.error.bad_request')} />
  {/if}
  <button class="primary" disabled={value.trim().length === 0} onclick={() => void save()}>
    {t('onboarding.continue')}
  </button>
</div>

<style>
  .onboarding {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 24px;
    gap: 10px;
    max-width: 420px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
  }
  .logo {
    width: 72px;
    height: 72px;
    border-radius: 18px;
    background: var(--brand);
    color: var(--brand-ink);
    font-size: 40px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
  }
  h1 {
    margin: 0;
    font-size: 24px;
  }
  p {
    margin: 0 0 10px;
    color: var(--ink-soft);
  }
  input {
    border: 1px solid var(--line);
    border-radius: 10px;
    padding: 14px;
    font-size: 20px;
    background: var(--surface);
    color: var(--ink);
    letter-spacing: 0.06em;
  }
  input:focus {
    outline: 2px solid var(--brand);
    border-color: transparent;
  }
  .primary {
    margin-top: 10px;
    border: 0;
    border-radius: 999px;
    background: var(--brand);
    color: var(--brand-ink);
    font-size: 16px;
    font-weight: 600;
    padding: 14px;
    cursor: pointer;
  }
  .primary:disabled {
    opacity: 0.5;
  }
  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
  }
</style>
